import React from 'react';
import { IconButton, TextField, Button, MenuItem } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import AddBoxIcon from '@material-ui/icons/AddBox';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import DescriptionIcon from '@material-ui/icons/Description';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FeedbackIcon from '@material-ui/icons/Feedback';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import HealingIcon from '@material-ui/icons/Healing';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import LocalPharmacyIcon from '@material-ui/icons/LocalPharmacy';
import MoodIcon from '@material-ui/icons/Mood';
import NotesIcon from '@material-ui/icons/Notes';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import PersonIcon from '@material-ui/icons/Person';
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot';
import SpaIcon from '@material-ui/icons/Spa';
import SubjectIcon from '@material-ui/icons/Subject';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

const ICON_MAP = {
    AddBox: AddBoxIcon,
    Assignment: AssignmentIcon,
    AssignmentTurnedIn: AssignmentTurnedInIcon,
    BubbleChart: BubbleChartIcon,
    Description: DescriptionIcon,
    EmojiObjects: EmojiObjectsIcon,
    Favorite: FavoriteIcon,
    Feedback: FeedbackIcon,
    FitnessCenter: FitnessCenterIcon,
    Healing: HealingIcon,
    HowToReg: HowToRegIcon,
    ListAlt: ListAltIcon,
    LocalHospital: LocalHospitalIcon,
    LocalPharmacy: LocalPharmacyIcon,
    Mood: MoodIcon,
    Notes: NotesIcon,
    OndemandVideo: OndemandVideoIcon,
    Person: PersonIcon,
    ScatterPlot: ScatterPlotIcon,
    Spa: SpaIcon,
    Subject: SubjectIcon,
    VerifiedUser: VerifiedUserIcon
};

const cardStyle = {
    position: 'relative',
    border: '1px solid #d8dbe0',
    borderRadius: 6,
    padding: '12px 16px 16px',
    margin: '8px 0',
    background: '#fafbfc'
};

const cardHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8
};

const stepBadgeStyle = {
    width: 26,
    height: 26,
    borderRadius: '50%',
    background: '#eaedf1',
    color: '#52596a',
    fontWeight: 700,
    fontSize: 13,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10
};

const fullWidthField = { width: '100%', marginBottom: 10 };

const ICON_NAMES = [
    'AddBox',
    'Assignment',
    'AssignmentTurnedIn',
    'BubbleChart',
    'Description',
    'EmojiObjects',
    'Favorite',
    'Feedback',
    'FitnessCenter',
    'Healing',
    'HowToReg',
    'ListAlt',
    'LocalHospital',
    'LocalPharmacy',
    'Mood',
    'Notes',
    'OndemandVideo',
    'Person',
    'ScatterPlot',
    'Spa',
    'Subject',
    'VerifiedUser'
].sort();

const LANGUAGES = [
    { value: '', label: 'Any' },
    { value: 'en-us', label: 'English (US)' },
    { value: 'es', label: 'Spanish' },
    { value: 'fr', label: 'French' },
    { value: 'zh', label: 'Chinese (Simplified)' },
    { value: 'zh-tw', label: 'Chinese (Traditional)' }
];

function parseConfig(raw) {
    if (!raw) return [];
    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
        console.error('preVisitActions parse error:', err);
        return [];
    }
}

function modelsToString(models) {
    if (!Array.isArray(models)) return '';
    return models.join(', ');
}

function stringToModels(str) {
    if (!str) return [];
    return str.split(',').map((m) => m.trim()).filter(Boolean);
}

class DebouncedColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: props.value };
        this.timer = null;
    }
    componentDidUpdate(oldProps) {
        if (oldProps.value !== this.props.value && this.props.value !== this.state.value) {
            this.setState({ value: this.props.value });
        }
    }
    componentWillUnmount() {
        if (this.timer) clearTimeout(this.timer);
    }
    onChange = (e) => {
        const value = e.target.value;
        this.setState({ value });
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.timer = null;
            this.props.onCommit(value);
        }, this.props.delay || 250);
    }
    render() {
        const { value } = this.state;
        const { label, style } = this.props;
        return <TextField style={style} type='color' label={label} InputLabelProps={{ shrink: true }} value={value} onChange={this.onChange} />;
    }
}

export class PreVisitActionsConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = { org: props.org };
    }

    render() {
        const { onChange } = this.props;
        const { org } = this.state;
        const items = parseConfig(org.config['preVisitActions']);

        const onUpdateOrg = () => {
            if (items.length === 0) {
                delete org.config['preVisitActions'];
            } else {
                org.config['preVisitActions'] = JSON.stringify(items);
            }
            this.setState({ org }, () => {
                if (onChange) onChange(org);
            });
        };

        return <div style={{ padding: '8px 12px' }}>
            {items.map((item, i) => (
                <div key={`item-${i}`} style={cardStyle}>
                    <div style={cardHeaderStyle}>
                        <span style={{ display: 'flex', alignItems: 'center', fontWeight: 600, color: '#52596a', fontSize: 13 }}>
                            <span style={stepBadgeStyle}>{i + 1}</span>
                            Button {i + 1}
                        </span>
                        <IconButton size='small' onClick={() => {
                            items.splice(i, 1);
                            onUpdateOrg();
                        }}><DeleteIcon fontSize='small' /></IconButton>
                    </div>
                    <TextField style={fullWidthField} label='Title' value={item.title || ''} onChange={(e) => {
                        item.title = e.target.value;
                        onUpdateOrg();
                    }} />
                    <TextField variant='outlined' style={fullWidthField} multiline={true} minRows={2} maxRows={4} label='Description' value={item.description || ''} onChange={(e) => {
                        item.description = e.target.value;
                        onUpdateOrg();
                    }} />
                    <div style={{ display: 'flex', gap: 12, marginBottom: 10 }}>
                        <TextField select style={{ width: 220 }} label='Icon (optional)' value={item.icon || ''} onChange={(e) => {
                            item.icon = e.target.value;
                            onUpdateOrg();
                        }}>
                            <MenuItem value=''>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                    <VerifiedUserIcon fontSize='small' style={{ color: '#888' }} />
                                    <span>Default (Report Symptoms)</span>
                                </span>
                            </MenuItem>
                            {ICON_NAMES.map((name) => {
                                const IconComp = ICON_MAP[name];
                                return <MenuItem key={name} value={name}>
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                        {IconComp ? <IconComp fontSize='small' /> : null}
                                        <span>{name}</span>
                                    </span>
                                </MenuItem>;
                            })}
                        </TextField>
                        <TextField select style={{ width: 220 }} label='Language (optional)' value={item.language || ''} onChange={(e) => {
                            item.language = e.target.value;
                            onUpdateOrg();
                        }}>
                            {LANGUAGES.map((l) => <MenuItem key={l.value || 'any'} value={l.value}>{l.label}</MenuItem>)}
                        </TextField>
                    </div>
                    <div style={{ display: 'flex', gap: 12, marginBottom: 10, alignItems: 'flex-end' }}>
                        <DebouncedColorPicker style={{ width: 120 }} label='Icon color' value={item.color || '#51cc42'} onCommit={(v) => {
                            item.color = v;
                            onUpdateOrg();
                        }} />
                        <DebouncedColorPicker style={{ width: 120 }} label='Background' value={item.bgColor || '#ffffff'} onCommit={(v) => {
                            item.bgColor = v;
                            onUpdateOrg();
                        }} />
                    </div>
                    <div style={{ display: 'flex', gap: 12, marginBottom: 10 }}>
                        <TextField style={{ flex: 1 }} label='Data ID (optional)' value={item.dataId || ''} onChange={(e) => {
                            item.dataId = e.target.value;
                            onUpdateOrg();
                        }} />
                        <TextField style={{ width: 120 }} type='number' label='Days' value={item.days === undefined || item.days === null ? '' : item.days} onChange={(e) => {
                            const v = e.target.value;
                            item.days = v === '' ? undefined : Number(v);
                            onUpdateOrg();
                        }} />
                    </div>
                    <TextField style={fullWidthField} label='Models (comma-separated)' value={modelsToString(item.models)} onChange={(e) => {
                        item.models = stringToModels(e.target.value);
                        onUpdateOrg();
                    }} />
                </div>
            ))}
            <Button size='small' startIcon={<AddIcon />} onClick={() => {
                items.push({ icon: '', title: '', description: '', language: '', models: [], dataId: '', days: 1, color: '#51cc42', bgColor: '' });
                onUpdateOrg();
            }}>Add button</Button>
        </div>;
    }
}

export default PreVisitActionsConfig;
